import { UserSubactivity } from './user-subactivity';
import { UserActivity } from './user-activity';
import { BaseManufacturingOrder } from './base-manufacturing-order';

export class WorkingHour {
  created: any;
  public open: boolean;

  constructor(
    public hash?: string,
    public userHash?: string,
    public userName?: string,
    public userActivity?: UserActivity,
    public userSubactivity?: UserSubactivity,
    public manufacturingOrder?: BaseManufacturingOrder,
    public day?: number,
    public totalTime?: number,
    public editable?: boolean,
    public observation?: string,
    public validated?: boolean,
    public userActivityName?: string,
    public userSubactivityName?: string,
    public erpTask?: number,
    public modelHash?: string,
    public modelName?: string,
    public nonConformityCode?: string,
    public nonProductiveManufacturingOrderCategoryHash?: string,
    public nonProductiveManufacturingOrderCategoryName?: string
  ) { }

  get isCompleted() {
    return this.manufacturingOrder !== null && this.userActivity !== null;
  }

  get projectName() {
    return this.nonConformityCode ? this.nonConformityCode : this.manufacturingOrder.projectNumber;
  }

  toggleOpen() {
    this.open = !this.open;
  }

  get manufacturingOrderCode() {
    return this.manufacturingOrder.codeWithNumber;
  }

  clone() {
    return new WorkingHour(
      this.hash,
      this.userHash,
      this.userName,
      this.userActivity,
      this.userSubactivity,
      this.manufacturingOrder,
      this.day,
      this.totalTime,
      this.editable,
      this.observation,
      this.validated,
      this.userActivityName,
      this.userSubactivityName,
      this.erpTask,
      this.modelHash,
      this.modelName,
      this.nonConformityCode,
      this.nonProductiveManufacturingOrderCategoryHash,
      this.nonProductiveManufacturingOrderCategoryName
    );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/working-hour.ts